
const CollisionDetectorCanvas = document.createElement('canvas');
const CollisionDetectorContext = CollisionDetectorCanvas.getContext('2d');

// @ts-ignore
window.getCollisionCanvas = () => {
  CollisionDetectorCanvas.toBlob((e) => {
    window.open(URL.createObjectURL(e));
  });
};

export default class CollisionDetector {

  static pixelHitTest(canvas, pos) {
    const context = CollisionDetectorContext;
    if (
      canvas.width !== CollisionDetectorCanvas.width
      || canvas.height !== CollisionDetectorCanvas.height
    ) {
      CollisionDetectorCanvas.width = canvas.width;
      CollisionDetectorCanvas.height = canvas.height;
    }

    context.clearRect(0, 0, CollisionDetectorCanvas.width, CollisionDetectorCanvas.height);
    context.drawImage(canvas, 0, 0);
    context.fillStyle = '#FFFFFF';

    context.save();
    context.globalCompositeOperation = 'source-in';
    // Larger hit area on touch devices for easier logo selection
    const hitSize = ('ontouchstart' in window) ? 15 : 5;
    const halfHit = Math.floor(hitSize / 2);
    context.fillRect(pos.x - halfHit, pos.y - halfHit, hitSize, hitSize);
    context.restore();

    return (
      new Uint32Array(context.getImageData(0, 0, CollisionDetectorCanvas.width, CollisionDetectorCanvas.height).data.buffer)
    ).some(color => color !== 0);
  }

  static boxHitTest(vec, obj, touchPadding = 0) {
    return vec.x > (obj.x ?? 0) - touchPadding
      && vec.y > (obj.y ?? 0) - touchPadding
      && vec.x < (obj.x ?? 0) + obj.width + touchPadding
      && vec.y < (obj.y ?? 0) + obj.height + touchPadding;
  }

  static boxHitMouseMatTest(vec, obj, maskT, maskB, maskL, maskR ){
    return vec.x > (obj.x ?? 0)
        && vec.y > (obj.y ?? 0)
        && vec.x > (obj.y ?? 0) + maskT
        && vec.x < (obj.y ?? 0) + maskB
        && vec.y < (obj.y ?? 0) + maskL
        && vec.y > (obj.y ?? 0) + maskR;
  }

  static boxHitTestMouseControl(vec,vec_x,vec_x2,vec_y,vec_y2,vec_y3,vec_y4,obj){
    return vec.x > (obj.x ?? 0)
        && vec.y > (obj.y ?? 0)
        && vec.x > (obj.x ?? 0) + vec_x
        && vec.x < (obj.x ?? 0) + vec_x2
        && vec.y > (obj.y ?? 0) + vec_y
        && vec.y < (obj.y ?? 0) + vec_y2
        || (vec.y < (obj.y ?? 0) + vec_y4
            && vec.y > (obj.y ?? 0) + vec_y3)
  }
}
